import ConnectedMyDrawer from './MyDrawer';

export default ConnectedMyDrawer;